import React, { useState, useEffect ,useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { NumericFormat } from 'react-number-format';
import Moment from 'react-moment';//Both are required here
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
//import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import setSeconds from 'date-fns/setSeconds';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const AuctionHistory = () => {
    const [reportData, setReportData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [selectedRow, setSelectedRow] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const api = useApi();
    const gridRef = useRef();
    const navigate = useNavigate();

    const loadReport = async () => {
        await api.getReport('AuctionHistory', {}).then((data) => {
            setReportData(data);
        })
    }

    useEffect(() => {
        loadReport();
    }, []);

    const dateRenderer = (props, format) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span>{cellValue ? <Moment format={format}>{cellValue}</Moment> : null}</span>
            </span>
        );
    };

    const viewSummaryReport = () => {
        setModalVisible(true);
    };

    const viewLotDetailsReport = () => {
        navigate(`/lotDetailReport/${selectedRow.AuctionId}`);
    };
    const viewBidderDetailReport = () => {
        navigate(`/bidderDetailReport/${selectedRow.AuctionId}`);
    };

    const downloadCSRReport = async (e) => {
        e.preventDefault();
        try {
            const { fileName, fileData } = await api.downloadReport('CSR', selectedRow.AuctionId);
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }
    }
    const downloadPriceListReport = async (e) => {
        e.preventDefault();
        try {
            const { fileName, fileData } = await api.downloadReport('PriceList', selectedRow.AuctionId);
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }
    }
    const downloadAdvanceAuctionReport = async (e, type) => {
        e.preventDefault();
        try {
            
            let reportName = "AdvanceAuction";
            if (type === "planter")
                reportName = "AdvanceAuction-Planter";
            else if (type === "dealer")
                reportName = "AdvanceAuction-Dealer";
            else if (type === "speciallots")
                reportName = "AdvanceAuction-SpecialLots";
          
            const { fileName, fileData } = await api.downloadReport(reportName, selectedRow.AuctionId);
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }
    }

    const downloadDetailedAuctionReport = async (e) => {
        e.preventDefault();
        try {
            const { fileName, fileData } = await api.downloadReport('DetailedAuction', selectedRow.AuctionId);
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }
    }
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            document.getElementById("filter-text-box").value,
        );
    }, []);

    
    const handleClose = () => {
        setModalVisible(false);
    };
    const qtyRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat suffix={' Kg'} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const columns = [
        { headerName: '', field: '#', checkboxSelection: true, headerClass: 'text-center', cellClass: 'text-center', width: 35 },
        { headerName: 'Auction Id', field: 'AuctionId', headerClass: 'text-center', cellClass: 'text-center', width: 70 },
        { headerName: 'Auctioneer', field: 'CompanyName', headerClass: 'text-center', flex: 1 },
        { headerName: 'Auction No', field: 'AuctionNo', headerClass: 'text-center', cellClass: 'text-center', width: 70 },
        { headerName: 'Auction Date', field: 'AuctionDate', headerClass: 'text-center', cellClass: 'text-center', width: 100, cellRenderer: (props) => dateRenderer(props, 'DD-MMM-YYYY') },
        { headerName: 'Status', field: 'AuctionStatus', headerClass: 'text-center', cellClass: 'text-center', width: 85 },
        { headerName: 'Start Time', field: 'StartTime', headerClass: 'text-center', cellClass: 'text-center', width: 70, cellRenderer: (props) => dateRenderer(props, 'LT') },
        { headerName: 'End Time', field: 'EndTime', headerClass: 'text-center', cellClass: 'text-center', width: 70, cellRenderer: (props) => dateRenderer(props, 'LT') },
        { headerName: 'Total Lots', field: 'TotalLots', headerClass: 'text-center', cellClass: 'text-center', width: 70 },
        { headerName: 'Total Arrivals (Kg)', field: 'TotalArrivals', headerClass: 'text-center', width: 80 },
        { headerName: 'Total Sales (Kg)', field: 'TotalSales', headerClass: 'text-center', cellClass: 'text-center', width: 80 },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            sortable: false,
        },
        rowSelection: 'single',
        suppressRowClickSelection: true,
        columnDefs: columns,
        rowClass: 'custom-grid-font',
       
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const onSelectionChanged = () => {
        const selectedRows = gridApi.getSelectedRows();
        setSelectedRow(selectedRows[0]);
       // console.log('Selected Rows:', selectedRows);
    };

    const exportToExcel = () => {

        const params = {
            suppressQuotes: false,
            columnSeparator: ',',
        };

        const data = gridApi.getDataAsCsv(params);

        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        const fileName = 'Auction Price Report.csv';

        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Auction History</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Auction History</li>
                    </ol>
                </div>
                <div className="d-flex">
                    <div className="justify-content-center">
                        {/*<button className="btn ripple btn-outline-danger pd-x-10 mg-r-10 btn-sm" type="button" onClick={exportToPdf}>*/}
                        {/*    <i class="ti ti-import me-2"></i>Export to pdf*/}
                        {/*</button>*/}
                        <button className="btn ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" onClick={exportToExcel}>
                            <i class="ti ti-import me-2"></i>Export to csv
                        </button>
                    </div>
                </div>
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mg-b-8">
                                <div>
                                    {selectedRow != null && Object.keys(selectedRow).length > 0 ?
                                        <div className="d-flex justify-content-around mg-t-4">
                                            <div className="btn-list mg-r-20">
                                                <button className="btn btn-sm ripple btn-outline-primary fs-11" onClick={viewSummaryReport}>Summary</button>
                                                <button className="btn btn-sm ripple btn-outline-primary fs-11" onClick={viewLotDetailsReport}>Lot Details</button>
                                                <button className="btn btn-sm ripple btn-outline-primary fs-11" onClick={viewBidderDetailReport}>Bidder Details</button>
                                            </div>
                                            <div className="btn-list">
                                                <button className="btn btn-sm ripple btn-outline-info fs-11" onClick={(e)=>downloadCSRReport(e)}> <i class="ti ti-import me-1"></i> CSR Report</button>
                                                <button className="btn btn-sm ripple btn-outline-info fs-11" onClick={(e) => downloadPriceListReport(e)}> <i class="ti ti-import me-1"></i> Price List</button>
                                                {/*<button className="btn btn-sm ripple btn-outline-info fs-11" onClick={(e) => downloadAdvanceAuctionReport(e)}> <i class="ti ti-import me-1"></i> Advance Report</button>*/}
                                                <button className="btn btn-sm ripple btn-outline-info fs-11" onClick={(e) => downloadDetailedAuctionReport(e)}> <i class="ti ti-import me-1"></i> Detailed Auction Report</button>
                                            </div>
                                            <Dropdown className="btn-list ms-1 ps-1">
                                                <Dropdown.Toggle variant="info" className="btn btn-sm ripple fs-11" >
                                                    <i class="ti ti-import me-1"></i> Advance Report <i class="ti ti-angle-down align-self-end fs-10"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ marginTop: "0px" }}>
                                                    <Dropdown.Item onClick={(e) => downloadAdvanceAuctionReport(e,'planter')} >Advance report - Planter </Dropdown.Item>
                                                    <Dropdown.Item onClick={(e) => downloadAdvanceAuctionReport(e,'dealer')} >Advance report - Dealer</Dropdown.Item>
                                                    <Dropdown.Item onClick={(e) => downloadAdvanceAuctionReport(e,'speciallots')} >Advance report - Special auction lots</Dropdown.Item>
                                                    <Dropdown.Item onClick={(e) => downloadAdvanceAuctionReport(e,'all')} >Advance report - All</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                           

                                        </div> : <cite className="text-muted">Select a row to view row options</cite>}
                                </div>
                                <div>
                                    <input type="text" className="form-control" id="filter-text-box" onChange={onFilterTextBoxChanged} placeholder="type to filter"></input>
                                </div>
                            </div>
                            <div
                                style={{ height: 500 }}
                                className={
                                    "ag-theme-alpine"
                                }
                            >
                                <AgGridReact
                                    ref={gridRef}
                                    rowHeight={36}
                                    gridOptions={gridOptions}
                                    rowData={reportData}
                                    onGridReady={onGridReady}
                                    onSelectionChanged={onSelectionChanged}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/*size='lg'*/}
            <Modal show={modalVisible} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Auction Summary</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pd-x-40">
                    <div className="row">
                        <table className="table">
                            <tbody >
                                <tr className="border-bottom pd-4">
                                    <th>Auction Id : </th>
                                    <td>{ selectedRow?.AuctionId}</td>
                                </tr>
                                <tr className="border-bottom ">
                                    <th>Auctioneer Name : </th>
                                    <td>{selectedRow?.CompanyName}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Auction Number : </th>
                                    <td>{selectedRow?.AuctionNo}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Lots : </th>
                                    <td>{selectedRow?.TotalLots}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Quantity : </th>
                                    <td>{selectedRow?.TotalArrivals}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Sold Quantity :</th>
                                    <td>{selectedRow?.TotalSales}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Sell Value : </th>
                                    <td>{selectedRow?.TotalSaleValue}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Bids :</th>
                                    <td>{selectedRow?.TotalBids}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Bidders :</th>
                                    <td>{selectedRow?.TotalBidders}</td>
                                </tr>
                            </tbody>
                            </table>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AuctionHistory;



